import React, { ComponentType } from 'react';
import { useFirebaseAuth } from './FirebaseAuthProvider';
import { useNavigate } from 'react-router-dom';

// HOC to inject Firebase auth into class components
export function withFirebaseAuth<P extends object>(
  WrappedComponent: ComponentType<P>
): ComponentType<Omit<P, 'firebaseAuth'>> {
  return function WithFirebaseAuthWrapper(props: Omit<P, 'firebaseAuth'>) {
    const firebaseAuth = useFirebaseAuth();
    const navigate = useNavigate();

    // Redirect to login if not authenticated
    React.useEffect(() => {
      if (!firebaseAuth.loading && !firebaseAuth.isAuthenticated) {
        navigate('/login');
      }
    }, [firebaseAuth.loading, firebaseAuth.isAuthenticated, navigate]);

    if (firebaseAuth.loading) {
      return <div>Loading...</div>;
    }

    return <WrappedComponent {...(props as P)} firebaseAuth={firebaseAuth} />;
  };
}
